export function WebhookDocs() {
    return (
      <div>
        <h2 className="fw-bold">Webhooks</h2>
        <p className="text-muted">Register a URL to receive real-time notifications about your message status.</p>
        
        <h6 className="fw-bold mt-4">Payload Format (JSON)</h6>
        <div className="bg-dark text-white p-4 rounded-4">
          <pre className="mb-0" style={{ fontSize: '0.85rem', color: '#a6accd' }}>
  {`{
    "event": "message.status",
    "data": {
      "message_id": "MSG_17359123",
      "status": "delivered",
      "to": "1234567890",
      "timestamp": "2026-01-03T12:00:00Z"
    }
  }`}
          </pre>
        </div>
        
        <div className="Swal Swal-warning border-0 rounded-4 mt-4 small">
          <i className="fas fa-exclamation-triangle me-2"></i>
          Your server must respond with a <strong>200 OK</strong> to acknowledge receipt.
        </div>
      </div>
    );
  }